import React from 'react';
import { ReactComponent as IconLoader } from '../assets/images/loader.svg';

const Loader = props => {
  return (
    <div className="loader" {...props}>
      <IconLoader />
      {props.title}
    </div>
  )
}

export default Loader;